export default __webpack_public_path__ + "static/media/martinize_all_atoms.dea1927d.png";